import { useMutation } from '@tanstack/react-query';

import ProductsService, {
  SearchDto,
  SearchParams,
} from '@/services/ProductsService';

export function useSearchAlternativeProducts() {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: ({
      searchDto,
      searchParams,
    }: {
      searchDto: SearchDto;
      searchParams: SearchParams;
    }) => ProductsService.searchAlternativeProducts(searchDto, searchParams),
  });

  return {
    searchAlternativeProducts: mutateAsync,
    isLoading: isPending,
  };
}
